import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import StepRoutes from "../../../Routes/steps_routes";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcInspection } from "react-icons/fc";
import SimpleButton from "../../../Components/layouts/simple_button";

const ShowWebinarFeedback = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/webinar/get-webinar-feedback-by-customer/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting employee feedback!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcInspection className="fs-2 me-1" />
                  Webinar Feedback
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
              {/* <div className="col-md-4 ">
                <div className="btn-list justify-content-end">
                  <button
                    className="btn btn-primary d-none d-sm-block"
                    onClick={handleMarkAsRead}
                    disabled={data?.markAsRead}
                  >
                    MARK AS READ
                  </button>
                </div>
              </div> */}
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Webinar Feedback</h2>
            </div>

            <div className="card-body">
              {data && (
                <>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Webinar Name:
                    </label>
                    <div className="w-100 col">
                      {data?.webinar?.webinarName || "N/A"}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Webinar Date:
                    </label>
                    <div className="w-100 col">
                      {data?.webinar?.webinarDate || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Feedback Rating:
                    </label>
                    <div className="w-100 col">
                      {data?.feedbackRating || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Feedback Description:
                    </label>
                    <div className="w-100 col">{data?.feedback || "N/A"}</div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Feedback Email:
                    </label>
                    <div className="w-100 col">{data?.email || "N/A"}</div>
                  </div>
                </>
              )}
            </div>
            <div className="card-footer">
              <div className="text-end">
                <SimpleButton buttonText="CANCEL" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ShowWebinarFeedback;
